import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
import { Control, actions } from "react-redux-form/immutable"
import ApprovedIcon from "react-icons/lib/md/lock"
import SubmittedIcon from "react-icons/lib/md/bookmark-outline"
import UnlockReqIcon from "react-icons/lib/md/lock-open"
import CancelUnlockReqIcon from "react-icons/lib/md/lock-outline"
import cn from "classnames"

import { getGrade, computeFg } from "utils/helpers"

class ListStudentItem extends Component {
  _openConfirmUnlock = () => {
    this.props.openConfirmUnlock(this.props.item.get("id"))
  }

  _openConfirmCancelUnlock = () => {
    this.props.openConfirmCancelUnlock(this.props.item.get("id"))
  }

  _onKeyDown = e => {
    if (e.keyCode === 13) {
      e.preventDefault()
      this.props.focusNext(this.props.k, e.target.name.split(".")[2])
    }
  }

  _onBlur = e => {
    const { __grades, k, item, dispatch } = this.props
    // validate
    const term = e.target.name.split(".")[2]
    const value = e.target.value
    let passed = false
    let isValid = true
    let failed = false
    let thisGrade = null

    if (term !== "re") {
      if (value) {
        thisGrade = getGrade(value, __grades.get("regular"))
        if (!thisGrade) {
          isValid = false
        } else {
          failed = !thisGrade.get("passed")
        }
      }
    } else {
      if (value) {
        thisGrade = getGrade(value, __grades.get("re"))
        if (!thisGrade) {
          isValid = false
        } else {
          failed = !thisGrade.get("passed")
        }
      }
    }
    dispatch(actions.change(`classState.students[${k}].${term}_failed`, failed))
    dispatch(actions.setValidity(e.target.name, isValid))

    // compute fg
    const fg = computeFg(item.get("mt"), item.get("ft"))
    dispatch(actions.change(`classState.students[${k}].fg`, fg))
    if (fg) {
      let thisGrade = getGrade(fg, __grades.get("regular"))
      if (thisGrade) {
        passed = thisGrade.get("passed")
        dispatch(
          actions.change(
            `classState.students[${k}].fg_failed`,
            !thisGrade.get("passed")
          )
        )
      }
      // check re
      if (item.get("re")) {
        const reGrade = getGrade(item.get("re"), __grades.get("re"))
        if (reGrade) {
          passed = reGrade.get("passed")
        }
      }
    }

    dispatch(actions.change(`classState.students[${k}].passed`, passed))
  }

  render() {
    const { __form, item, k } = this.props
    const isSubmitted = item.getIn(["grade_submission_id", "Valid"])
    let ch = <Control.checkbox model={`.students[${k}].is_checked`} />
    let stat = null
    if (!__form || !__form[k]) {
      return null
    }

    // class Validation for each grades
    const mtCl = cn("text-right", {
      error: !__form[k].mt.valid,
      failed: item.get("mt_failed"),
    })
    const ftCl = cn("text-right", {
      error: !__form[k].ft.valid,
      failed: item.get("ft_failed"),
    })
    const fgCl = cn("text-right active", {
      failed: item.get("fg_failed"),
    })
    const reCl = cn("text-right", {
      error: !__form[k].re.valid,
      failed: item.get("re_failed"),
    })

    let cl = ""
    if (item.get("passed") === false) {
      cl = "danger"
    }

    if (isSubmitted) {
      cl = "active"
    }

    if (isSubmitted) {
      stat = <SubmittedIcon />
      ch = null
    }
    if (item.get("is_locked")) {
      stat = <ApprovedIcon />
      ch = (
        <button
          onClick={this._openConfirmUnlock}
          type="button"
          className="btn-icon btn-inline"
        >
          <UnlockReqIcon />
        </button>
      )
      if (item.get("action") === 5) {
        ch = (
          <button
            onClick={this._openConfirmCancelUnlock}
            type="button"
            className="btn-icon btn-inline"
          >
            <CancelUnlockReqIcon className="text-danger" />
          </button>
        )
      }
    }

    return (
      <tr className={cl}>
        <td className="text-center">{ch}</td>
        <td>{k + 1}.</td>
        <td>
          <small>{item.get("student_id")}</small>
        </td>
        <td className="text-center">{stat}</td>
        <td>{item.get("student_name")}</td>
        <td className={mtCl}>
          <Control.text
            model={`.students[${k}].mt`}
            maxLength="3"
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
            disabled={isSubmitted}
          />
        </td>
        <td className={ftCl}>
          <Control.text
            model={`.students[${k}].ft`}
            maxLength="3"
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
            disabled={isSubmitted}
          />
        </td>
        <td className={fgCl}>
          <Control.text
            model={`.students[${k}].fg`}
            maxLength="3"
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
            disabled
          />
        </td>
        <td className={reCl}>
          <Control.text
            model={`.students[${k}].re`}
            maxLength="3"
            onKeyDown={this._onKeyDown}
            onBlur={this._onBlur}
            disabled={isSubmitted}
          />
        </td>
      </tr>
    )
  }
}

ListStudentItem.propTypes = {
  item: PropTypes.object,
  offeringGroupID: PropTypes.string,
  k: PropTypes.number,
  focusNext: PropTypes.func,
}

function mapStateToProps(state, ownProps) {
  return {
    __form: state.forms.classState.students,
    __grades: state.admin.get("grades"),
  }
}

export default connect(mapStateToProps)(ListStudentItem)



// WEBPACK FOOTER //
// ./src/containers/Grades/list-student-item.js